<app-toolbar>
    <app-tool-button text="Nou" i18n-text (click)="create();" color="has-color-green" icon="fa-plus-square"></app-tool-button>
    <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
    <!-- <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button> -->
    <!-- <app-tool-button text="Excel" i18n-text (click)="generateExcel();" color="has-color-darkgreen" icon="fa-file-excel"></app-tool-button> -->
</app-toolbar>

<app-seguretat-grups-table #table (itemClicked)="itemClicked($event)"></app-seguretat-grups-table>